import { gql } from '@apollo/client';

const commentFragment = gql`
  fragment CommentFields on AppraiserEventComment {
    Id
    ExternalUserId
    ExternalUserName
    Comment
    ModifiedDate
    IsEditable
    IsDeletable
    Type
    ActionType
    IsSystemSender
    Accessibilities {
      Title
      Accessibility
      TargetUserId
    }
  }
`;

export default commentFragment;
